import { BiUser } from "react-icons/bi";
import { CiLocationOn } from "react-icons/ci";

import Star from "../SvgIcons/Star";

const Details = ({ seller = "Bencroft", location = "Pretoria" }) => {
  return (
    <div className="">
      <div className="flex items-center ">
        <BiUser className="mr-2 h-5 w-5 text-blue" />
        <span className="font-pop text-base font-light leading-8 text-cardSecondaryColor">
          {seller}
        </span>
      </div>

      <div className="flex items-center ">
        <Star className="mr-2 h-5 w-5" />
        <span className="font-pop text-base font-light leading-8 text-cardSecondaryColor">
          Watch this
        </span>
      </div>

      <div className="flex items-center ">
        <CiLocationOn className="mr-2 h-5 w-5 text-redBorder" />
        <span className="font-pop text-base font-light leading-8 text-cardSecondaryColor">
          {location}
        </span>
      </div>
    </div>
  );
};

export default Details;
